export default __webpack_public_path__ + "static/media/girl2.260a1229.svg";